var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftSLine3 = function SvgArrowLeftSLine3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.577 2 6.35 11a.667.667 0 0 1-.577 1H1.65a.668.668 0 0 1-.578-1l6.35-11a.667.667 0 0 1 1.155 0Zm-1.244 8.667V12h1.333v-1.333H7.333Zm0-4.667v3.333h1.333V6H7.333Z"
  })));
};
export default SvgArrowLeftSLine3;